import type { ComponentPropsWithoutRef, ElementType } from "react";
import { cn } from "../../utils/cn";

type DSCardProps<T extends ElementType = "div"> = {
  as?: T;
} & Omit<ComponentPropsWithoutRef<T>, "as">;

function DSCard<T extends ElementType = "div">({
  as,
  className,
  ...rest
}: DSCardProps<T>) {
  const Component = as ?? "div";
  return <Component className={cn("border border-solid border-gray-3 bg-body-light-mode-1 rounded-3xl p-6 font-inter", className)} {...rest} />;
}

export { DSCard };
export type { DSCardProps };
